<template>
  <div class="poll-v1" style="all: inherit; display: flex">
    <CountDownTime v-if="isShowCountDownTime" />
    <PollQuestionImage
      :class="{
        'default-canvas-image-width': questionImageLayoutMode === layoutMode.default,
        'full-canvas-image-width' : questionImageLayoutMode === layoutMode.image,
        'hide-canvas-image': questionImageLayoutMode === layoutMode.chart,
        'invisible': !isInvisiblePollQuestionImage,
      }"
      :questionImageLayoutMode="questionImageLayoutMode"
      @expandCollapseTrigger="updateQuestionImageLayoutMode"
    />
    <component
      :is="chartName"
      :class="{
        'default-chart-width': questionImageLayoutMode === layoutMode.default && questionImage,
        'full-chart-width' : questionImageLayoutMode === layoutMode.chart,
        'hide-chart': questionImageLayoutMode === layoutMode.image,
      }"
      :hasImage="questionImage"
      :questionImageLayoutMode="questionImageLayoutMode"
      @expandCollapseTrigger="updateQuestionImageLayoutMode"
    ></component>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import PollQuestionImage from '@/components-v2/presentation-editor/middle/poll/PollQuestionImage.vue'
import Utils from '@/util'
import constants from '@/constant'
import CountDownTime from './CountDownTime.vue'

const layoutMode = {
  default: 'default',
  chart: 'chart',
  image: 'image',
}
export default {
  components: {
    PollQuestionImage,
    CountDownTime,
    PollBarChart: () => import('@/components-v2/presentation-editor/middle/poll/PollBarChart.vue'),
    DonutChart: () => import('@/components/presentations/charts/DonutChart.vue'),
    PieChart: () => import('@/components/presentations/charts/PieChart.vue'),
  },
  data() {
    return {
      questionImageLayoutMode: layoutMode.chart,
      layoutMode,
      isInvisiblePollQuestionImage: true,
      requestFrame: null,
    }
  },
  computed: {
    ...mapGetters(['isPresenting']),
    ...mapState({
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
    }),
    questionImage() {
      return !!(this.slideActive.image && this.slideActive.image.xLarge)
    },
    chartName() {
      const { typeChart } = this.slideActive

      if (typeChart === 'pieChart') return 'PieChart'

      if (typeChart === 'donutChart') return 'DonutChart'

      return 'PollBarChart'
    },
    isShowCountDownTime() {
      return this.isPresenting && !this.slideActive.hideResult
    },
  },
  watch: {
    questionImage() {
      const hasQuestionImage = this.questionImage
      if (!hasQuestionImage) this.questionImageLayoutMode = layoutMode.chart
      else this.questionImageLayoutMode = layoutMode.default
    },
    slideActive(newValue, oldValue) {
      if (newValue.id !== oldValue.id) {
        this.isInvisiblePollQuestionImage = false
        if (!this.questionImage) this.questionImageLayoutMode = layoutMode.chart
        else this.questionImageLayoutMode = this.slideActive.questionImageLayout || layoutMode.chart
      }
      if (this.questionImage) setTimeout(() => { this.isInvisiblePollQuestionImage = true }, 100)
    },
  },
  mounted() {
    if (!this.questionImage) this.questionImageLayoutMode = layoutMode.chart
    else this.questionImageLayoutMode = this.slideActive.questionImageLayout || layoutMode.default
  },
  methods: {
    updateQuestionImageLayoutMode(mode) {
      if (!this.questionImage) return
      if (this.questionImageLayoutMode === layoutMode.default) { // switch to image, chart
        this.questionImageLayoutMode = mode
      } else {
        this.questionImageLayoutMode = layoutMode.default // switch to default
      }
      this.$emit('updateLayout', this.questionImageLayoutMode)
      // eslint-disable-next-line no-nested-ternary
      const evtAction = (mode === layoutMode.default) ? 'Question image > View default' : ((mode === layoutMode.chart ? 'Question image > View chart' : 'Question image > View image'))
      // eslint-disable-next-line max-len
      const evtCategory = this.isPresenting ? constants.eventCategories.PRESENTING_MODE : constants.eventCategories.PRESENTATION_EDITOR
      const evtLabel = this.questionImageLayoutMode === layoutMode.default ? 'Collapse' : 'Expand'
      const evtValue = ''
      // eslint-disable-next-line max-len
      const slideName = Utils.getCorrectSlideTypeName(this.slideActive.type, this.slideActive.slideType)
      Utils.mixpanelTracking(
        evtCategory,
        evtAction,
        evtLabel,
        evtValue,
        {
          slideType: slideName,
          slideId: this.slideActive.id,
          presentationId: this.presentation.id,
        },
      )
    },
  },
}
</script>
<style scoped lang='scss'>
.default-canvas-image-width {
  width: 30%;
  display: flex;
  animation: fadeIn;
  animation-duration: 0.75s;
}

.default-chart-width {
  width: 70% !important;
  cursor: zoom-in;
  animation: fadeIn;
  animation-duration: 0.75s;
  &.content-chart {
    cursor: unset;
  }
}

.full-canvas-image-width {
  width: 100%;
  animation: zoomIn;
  animation-duration: 0.3s;
  &:hover {
    background: rgba(209, 209, 209, 0.2);
  }
}

.hide-chart {
  display: none !important;
  cursor: none !important;
}

.full-chart-width {
  width: 100%;
  display: flex;
  animation: zoomIn;
  animation-duration: 0.3s;
}

.hide-canvas-image {
  display: none;
}
</style>
